module.exports = __webpack_public_path__ + "img/travel05.74a2d57f.jpg";